import { useEffect, useRef, useState } from "react";

const KEY = "desk_red_sound";

const beep = () => {
  const ctx = new (window.AudioContext || window.webkitAudioContext)();
  [0, 0.45, 0.9].forEach((t) => {
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = "square"; o.frequency.value = 880;
    g.gain.setValueAtTime(0.0001, ctx.currentTime + t);
    g.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.3);
    o.connect(g).connect(ctx.destination);
    o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + 0.32);
  });
  setTimeout(() => ctx.close(), 1500);
};

const useRedSound = (color) => {
  const [on, setOn] = useState(() => localStorage.getItem(KEY) === "1");
  const prev = useRef(color);
  useEffect(() => {
    if (on && color === "RED" && prev.current !== "RED") beep();
    prev.current = color;
  }, [color, on]);
  const toggle = () => { const v = !on; localStorage.setItem(KEY, v ? "1" : "0"); setOn(v); if (v) beep(); };
  return [on, toggle];
};

const DO = {
  GREEN: ["TRADE NORMALLY", "No big news due. Use your normal size and normal rules."],
  AMBER: ["BE CAREFUL", "Something may move gold. Use smaller size and tighter stops. No new big positions."],
  RED: ["NO NEW TRADES", "Big news now or very soon. Do not open trades. Protect or close open positions. Wait for AMBER or GREEN."],
};

const Legend = ({ color }) => (
  <div className="mt-5 pt-4 border-t border-white/15 space-y-2" data-testid="desk-light-legend">
    <div className="text-xs tracking-[.18em] uppercase opacity-70">What the colours mean</div>
    {Object.entries(DO).map(([c, [head, text]]) => (
      <div key={c} className={`flex gap-3 items-start text-sm ${c === color ? "" : "opacity-60"}`} data-testid={`desk-legend-${c}`}>
        <span className="mt-1 w-3 h-3 rounded-full shrink-0" style={{ background: `var(--${c.toLowerCase()})` }} />
        <span><b>{c}: {head}.</b> {text}</span>
      </div>
    ))}
  </div>
);

export const Light = ({ light }) => {
  const [sound, toggle] = useRedSound(light.color);
  const [head, text] = DO[light.color];
  return (
    <section className={`desk-light ${light.color}`} data-testid="desk-light">
      <div className="flex justify-between items-start gap-2">
        <h2>Right now</h2>
        <button className="desk-btn !py-1 !px-2 !text-xs" onClick={toggle} data-testid="desk-sound-toggle">{sound ? "Sound on" : "Sound off"}</button>
      </div>
      <div className="flex flex-wrap items-baseline gap-x-5 gap-y-1">
        <div className="big" data-testid="desk-light-color">{light.color}</div>
        <div className="text-2xl md:text-3xl font-bold tracking-wide" data-testid="desk-light-action">{head}</div>
      </div>
      <p className="mt-2 text-lg leading-snug font-semibold" data-testid="desk-light-todo">{text}</p>
      <p className="mt-3 text-base leading-snug opacity-80" data-testid="desk-light-reason">Why: {light.reason}</p>
      {light.all?.length > 1 && (
        <ul className="mt-2 text-sm text-[color:var(--mute)] space-y-1" data-testid="desk-light-all">
          {light.all.slice(1).map((r) => <li key={r}>· {r}</li>)}
        </ul>
      )}
      <Legend color={light.color} />
    </section>
  );
};
